import { TypedEventNode } from "./_Base";
import { Poly } from "../../Poly";
export class TypedCameraControlsEventNode extends TypedEventNode {
  constructor() {
    super(...arguments);
    this._controls_by_viewer = /* @__PURE__ */ new Map();
  }
  async applyControls(camera, viewer) {
    const canvas = viewer.canvas();
    if (!canvas) {
      return;
    }
    const controls = await this.createControlsInstance(camera, canvas);
    const current_controls = this._controls_by_viewer.get(viewer);
    if (current_controls) {
      current_controls.dispose();
    }
    this._controls_by_viewer.set(viewer, controls);
    const performance = Poly.performance.performanceManager();
    const timestamp = performance.now();
    controls.name = `${this.path()}:${camera.name}:${timestamp}:${this.controls_id()}`;
    await this.params.evalAll();
    this.setupControls(controls);
    return controls;
  }
  controls_id() {
    return JSON.stringify(this.params.all.map((p) => p.valueSerialized()));
  }
}
